import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useMeetingContext } from 'Context/MeetingContext';
import OldMCNotesContainer from './Notes/Container';
import useMissionControl from '../../../useMissionControl';

const styles = () => ({
  container: {}, // This style is only applied to the DataContainer
  root: {}, // This style is only applied to the DataContainer
});

const NotesContainer = ({
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { meetingResource, meetingLoadingError } = useMeetingContext();
  const { noMeetings } = useMissionControl();

  const isLoading = !meetingResource;

  return !noMeetings && (
    <DataContainer
      className={classes.container}
      component={OldMCNotesContainer}
      componentProps={{
        className: classes.root,
        householdResource,
        meetingResource,
      }}
      loading={isLoading}
      loadingError={meetingLoadingError}
    />
  );
};

NotesContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotesContainer);
